import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { LegalProtectionMetadataComponentAbstract } from '../../metadata-components/legal-protection-metadata/legal-protection-metadata.component.abstract';

@Component({
  selector: 'app-legal-protection-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, IconsModule, PdfViewerModalComponent],
  templateUrl: './legal-protection-metadata-v2.component.html',
})
export class LegalProtectionMetadataV2Component extends LegalProtectionMetadataComponentAbstract {}
